import { Box, Button, IconButton, Stack, Typography } from "@mui/material";
import { useDarkMode } from "../../../contexts/useDarkModeContext";
import SaveJobIcon from "../../../UI/SaveJobIcon";
import { useState } from "react";
const featuredCardsData = [
  {
    iconSrc: "/icons/locationIconReviewsSection.svg",
    iconSrcDarkMode: "/icons/locationIconReviewsSectionWhite.svg",
    text: "Seattle, WA",
  },
  {
    iconSrc: "/icons/moneyIcon.svg",
    iconSrcDarkMode: "/icons/moneyIconWhite.svg",
    text: "80,000 - 100,000 per year",
  },
];
const jobRequirements = [1, 2, 3];

function PopularJobCard() {
  const [saveJob, setSaveJob] = useState(false);
  const { darkMode } = useDarkMode();
  return (
    <Stack
      sx={{
        bgcolor: "#F8F8F8",
        border: "1px solid #E3E3E3",
        p: "20px",
        px: "22px",
        borderRadius: "20px",
      }}
    >
      <Typography
        sx={{
          fontSize: "18px",
          lineHeight: "26px",
          fontFamily: "Inter",
          fontWeight: "400",
          color: "#0E0B33",
          maxWidth: "790px",
        }}
      >
        Senior UI Designer
      </Typography>
      <Stack
        direction="row"
        sx={{ alignItems: "center", gap: "12px", py: "6px", pb: "18px" }}
      >
        {" "}
        <Box
          component="img"
          src="/images/marketingGenius.jpg"
          sx={{
            width: "36px",
            height: "36px",
            objectFit: "cover",
            borderRadius: "10px",
            display: "block",
            border: "none",
            bgcolor: "#D9D9D9",
          }}
        ></Box>
        <Typography
          variant="body2"
          sx={{
            fontWeight: "400",
            fontSize: "16px",
            lineHeight: "26px",
            fontFamily: "Inter",
            color: "#838296",
          }}
        >
          Creative Solutions, Inc.
        </Typography>
      </Stack>
      <Button
        variant="contained"
        sx={{
          borderRadius: "24px",
          px: "32px",
          minWidth: "auto",
          width: "auto",
          textTransform: "none",
          bgcolor: "#dfdfdf",
          color: "#000000",
          boxShadow: "none",
          py: "8px",
          fontSize: "14px",
          lineHeight: "24px",
          fontFamily: "Inter",
          fontWeight: "600",
          alignSelf: "start",
        }}
      >
        Full Time
      </Button>
      <Box sx={{ pt: "12px", pb: "2px" }}>
        {jobRequirements.map((require) => (
          <Typography
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              fontSize: "14px",
              lineHeight: "24px",
              fontFamily: "Inter",
              fontWeight: "400",
              color: "#838296",
              gap: "6px",
            }}
          >
            {" "}
            <Box
              sx={{
                width: "6px",
                height: "6px",
                bgcolor: "#838296",
                borderRadius: "50%",
              }}
            ></Box>
            Bachelor's degree in design or related
          </Typography>
        ))}
      </Box>
      <Box>
        {featuredCardsData.map((data) => (
          <>
            <Stack
              direction="row"
              sx={{
                alignItems: "center",
                gap: "6px",
                pt: "0px",
                justifyContent: "start",
              }}
            >
              <Box
                component="img"
                src={darkMode ? data.iconSrcDarkMode : data.iconSrc}
                sx={{ width: "15px", height: "15px" }}
              ></Box>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "400",
                  fontSize: "14px",
                  lineHeight: "24px",
                  fontFamily: "Inter",
                  color: darkMode ? "#c9c9c9" : "#0E0B33",
                  textAlign: "center",
                }}
              >
                {data.text}
              </Typography>
            </Stack>
          </>
        ))}
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: "18px",
          pt: "22px",
        }}
      >
        <Button
          variant="contained"
          sx={{
            borderRadius: "24px",
            px: "46px",
            minWidth: "auto",
            width: "auto",
            textTransform: "none",
            bgcolor: "#1E1E1E",
            color: "#ffffff",
            boxShadow: "none",
            py: "10px",
            fontSize: "16px",
            lineHeight: "26px",
            fontFamily: "Inter",
            fontWeight: "600",
            alignSelf: "start",
          }}
        >
          Apply This Job
        </Button>
        <IconButton
          sx={{
            border: "1px solid #040404",
            py: "10px",
            px: "20px",
            borderRadius: "30px",
            bgcolor: saveJob ? "#040404" : "transparent",
            "&:hover": {
              bgcolor: saveJob ? "#040404" : "transparent",
            },
            "&:active": {
              bgcolor: "transparent", // Prevents active (click) background color
            },
          }}
          onClick={() => setSaveJob(!saveJob)}
        >
          <SaveJobIcon color={`${saveJob ? "#ffffff" : "#040404"}`} />
        </IconButton>
      </Box>
    </Stack>
  );
}

export default PopularJobCard;
